import React from 'react'
import styled, { css } from 'styled-components'
import topVideoSrc from '../data/videos/zuri-11m-flight-demonstrator-proof-of-concept-early-vtol-test.mp4'
import Video from './Video'
import Section from './Section'
import { up } from '../lib/styles'

// const Wrapper = styled(Section.FullHeight)`
const Wrapper = styled.div`
  video {
    width: 100%;
  }
`

const HpShowReel = () => (
  <Wrapper>
    <Video
      src={topVideoSrc}
      centered
      muted
      autoPlay
      loop
      aria-label="Diagram showing forward flight mode of a hybrid VTOL aircraft with thrust vectors representing horizontal propulsion, highlighting aerodynamic efficiency during cruise."
    />
  </Wrapper>
)

export default HpShowReel
